export interface ApiRoutingPolicy {
  pageOrigin: string;
  production: boolean;
}

export const localDemoProxy = {
  '/api': 'http://127.0.0.1:8000',
  '/health': 'http://127.0.0.1:8000',
  '/ready': 'http://127.0.0.1:8000',
} as const;

export const localDemoViteRouting = {
  server: { port: 4173, proxy: localDemoProxy },
  preview: { port: 4173, proxy: localDemoProxy },
} as const;

/** Empty means same-origin. Explicit routing is origin-only and cannot carry secrets. */
export function validateApiOrigin(candidate: string | undefined, policy: ApiRoutingPolicy): string {
  const value = candidate?.trim() ?? '';
  if (!value) return '';

  let apiUrl: URL;
  let pageUrl: URL;
  try {
    apiUrl = new URL(value);
    pageUrl = new URL(policy.pageOrigin);
  } catch {
    throw new Error('VITE_API_BASE_URL must be an absolute HTTP(S) origin');
  }

  if (apiUrl.protocol !== 'http:' && apiUrl.protocol !== 'https:') throw new Error('VITE_API_BASE_URL must use HTTP or HTTPS');
  if (apiUrl.username || apiUrl.password) throw new Error('VITE_API_BASE_URL must not contain credentials');
  if (apiUrl.pathname !== '/' || apiUrl.search || apiUrl.hash) throw new Error('VITE_API_BASE_URL must contain only an origin');
  if (policy.production && apiUrl.protocol !== 'https:') throw new Error('VITE_API_BASE_URL must use HTTPS in production');
  if (!policy.production && apiUrl.protocol === 'http:' && !isLoopback(apiUrl.hostname)) {
    throw new Error('Insecure VITE_API_BASE_URL is allowed only for a loopback local demo');
  }

  return apiUrl.origin === pageUrl.origin ? '' : apiUrl.origin;
}

function isLoopback(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]';
}
